import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Modal,
  Tab,
  Tabs, // Ensure Tabs and Tab are imported
  Offcanvas,
} from "react-bootstrap";
import { Buttons, ClickButton } from "../components/Buttons";
import { TableUI } from "../components/Tables";
import { PageHead, PageTitle } from "../components/PageTitle";
import { FaMagnifyingGlass } from "react-icons/fa6";
import {
  Calender,
  DropDown,
  DropDownUI,
  LoadingSpinner,
  TextInputForm,
} from "../components/Forms";
import { Navigate } from "react-router-dom";
import { MdOutlineClose } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment/moment";
import Pagnation from "../components/Pagnation";
import API_DOMAIN from "../config/config";
import companyId from "../config/companyId";
import { generatePurchasePartyPdf } from "./purchasepartyPDF";
import jsPDF from "jspdf";
import "jspdf-autotable";

export function calculateTotals(transactions) {
  let totalPaid = 0;
  let totalBalance = 0;

  transactions.forEach((transaction) => {
    const paid = parseFloat(transaction.paid || 0);
    const balance = parseFloat(transaction.balance || 0);

    totalPaid += paid;
    if (transaction.type === "Payout") {
      totalBalance -= paid;
    } else {
      totalBalance += balance;
    }
  });
  return {
    paid: totalPaid.toFixed(2),
    balance: totalBalance.toFixed(2),
  };
}


;

const ProductHistory = [
  "S.No",
  "Date",
  "Bill No",
  "Amount",
  "Paid",
  "Payment Method",
  "Balance",
  "Detail",

];
const BalanceSheetHeaders = [
  "Date",
  "Particulars",
  "Credit",
  "Debit",
  "Balance",
  "Action",
];
const PurchasePartyTable = ["Name", "Action"];
const Party = () => {

  const [openFilter, setOpenFilter] = useState(false);
  const closeFilter = () => setOpenFilter(false);
  const showFilter = () => setOpenFilter(true);
  const navigate = useNavigate();
  const location = useLocation();
  const { type, rowData } = location.state || {};
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setPurchase(null);
    setFormData({
      party_id: "",
      phone_number: "",
      party_name: "",
      mobile_number: "",
      alter_number: "",
      email: "",
      company_name: "",
      gst_no: "",
      password: "",
      address: "",
      opening_balance: "",
      opening_date: "",
      ac_type: "",
      city: "",
      state: "",
    });
    setShow(true);
  };


  const [crtPurchase, setPurchase] = useState(null);
  const handleEditClick = (rowdata) => {
    setPurchase(rowdata);
    setShow(true);
  };
  const [formData, setFormData] = useState({
    party_id: "",
    phone_number: "",
    party_name: "",
    mobile_number: "",
    city: "",
    state: "",
    alter_number: "",
    email: "",
    company_name: "",
    gst_no: "",
    password: "",
    address: "",
    opening_balance: "",
    opening_date: "",
    ac_type: "",
  });

  const [userData, setUserData] = useState([]);
  const [resetKey, setResetKey] = useState(0);

  const handleChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    if (crtPurchase != null) {
      setPurchase({
        ...crtPurchase,
        [fieldName]: value,
      });
    } else {
      setFormData({
        ...formData,
        [fieldName]: value,
      });
    }
  };
  const [from_date, setFromDate] = useState(null);
  const [to_date, setToDate] = useState(null);

  const setDateLabel = (value, field) => {
    if (field === "from_date") {
      setFromDate(moment(value).format("YYYY-MM-DD"));
    } else if (field === "to_date") {
      setToDate(moment(value).format("YYYY-MM-DD"));
    }
  };
  const handleClearDates = () => {
    setFromDate(null);
    setToDate(null);
    setResetKey((prevKey) => prevKey + 1);
  };
  const [loading, setLoading] = useState(true);

  const [clickedData, setClickedData] = useState(null);

  const handleClick = (data) => {
    setClickedData(data);
    setFromDate("");
    setToDate("");
    setResetKey((prevKey) => prevKey + 1);
  };

  const [searchText, setSearchText] = useState("");
  const handleSearch = (value) => {
    setSearchText(value);
  };

  const filteredUserData = Object.values(userData).filter((item) =>
    item.party_name.toLowerCase().includes(searchText.toLowerCase())
  );

  const fetchData = async () => {
    try {
      const response = await fetch(`${API_DOMAIN}/purchase_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search_text: searchText,
          company_id: companyId,
          from_date: from_date,
          to_date: to_date,
        }),
      });

      const responseData = await response.json();

      if (responseData.status === 200) {
        setUserData(responseData.data);

        if (responseData.data.length > 0) {
          setClickedData(responseData.data[0]);
        }
      } else {
        throw new Error(responseData.msg);
      }
    } catch (error) { }
  };

  useEffect(() => {
    const initialFetch = async () => {
      try {
        const response = await fetch(`${API_DOMAIN}/purchase_party.php`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            search_text: searchText,
            company_id: companyId,
            from_date: "",
            to_date: "",
          }),
        });
        const responseData = await response.json();
        setLoading(false);
        if (responseData.status === 200) {
          setUserData(responseData.data);
          if (responseData.data.length > 0) {
            setClickedData(responseData.data[0]);
          }
        } else {
          throw new Error(responseData.msg);
        }
      } catch (error) {
        setLoading(false);
      }
    };
    initialFetch();
  }, []);

  useEffect(() => {
    if (clickedData) {
      if (from_date || to_date || searchText) {
        fetchData();
      }
    }
  }, [searchText, from_date, to_date]);

  const [showAlert, setShowAlert] = useState(false);
  const errorAlert = (input) => {
    toast.error(input, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };
  const successAlert = (success) => {
    toast.success(success, {
      position: "top-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleSubmit = async () => {
    if (formData.party_name === "") {
      errorAlert("Party is Must");
      return;
    }

    if (!isValidEmail(formData.email)) {
      errorAlert("Invalid Email Address");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/purchase_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          party_name: formData.party_name,
          mobile_number: formData.mobile_number,
          company_id: companyId,
          alter_number: formData.alter_number,
          email: formData.email,
          company_name: formData.company_name,
          gst_no: formData.gst_no,
          address: formData.address,
          city: formData.city,
          state: formData.state,
          opening_balance: formData.opening_balance,
          opening_date: formData.opening_date,
          ac_type: formData.ac_type,
        }),
      });
      const responseData = await response.json();
      setLoading(false);

      if (responseData.status === 200) {
        await fetchData(true);
        successAlert(responseData.msg);
        handleClose();
        window.location.reload();
      } else if (responseData.status === 400) {
        toast.error(responseData.msg, {
          position: "top-center",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        setShowAlert(true);
        errorAlert("Unexpected error occurred");
      }
    } catch (error) {
      setLoading(false);
      errorAlert("Network or server error. Please try again.");
    }
  };

  const sendWhatsAppStatement = async () => {
    if (!clickedData || !clickedData.mobile_number) {
      toast.error("Mobile number not available!");
      return;
    }

    try {
      /* ================= PDF INIT ================= */
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: [160, 90], // little bigger → better readability
      });

      const balanceSheet = [...(clickedData.party_wise_balance_sheet_report || [])]
        .sort((a, b) => new Date(b.Date) - new Date(a.Date));

      const transactions = Array.isArray(clickedData.transactions) ? clickedData.transactions : [];

      // Get the latest balance from balance sheet (index 0 because we sorted descending)
      const latestBalanceEntry = balanceSheet.length > 0 ? balanceSheet[0] : null;
      const finalBalance = latestBalanceEntry ? Number(latestBalanceEntry.Balance || 0) : 0;

      // Get last transaction details from balance sheet
      let latestParticulars = "";
      let lastTransactionAmount = 0;
      let isLastTxPayout = false;

      if (latestBalanceEntry) {
        latestParticulars = (latestBalanceEntry.Particulars || "").trim();

        // Check if Credit exists (even if it is 0)
        if (latestBalanceEntry.Credit !== undefined && latestBalanceEntry.Credit !== null && latestBalanceEntry.Credit !== "") {
          // If Credit is 0 or more, we use it
          if (Number(latestBalanceEntry.Credit) >= 0) {
            lastTransactionAmount = latestBalanceEntry.Credit;
            isLastTxPayout = true;
          }
        }
        // If Credit wasn't the focus, check Debit
        else if (latestBalanceEntry.Debit > 0) {
          lastTransactionAmount = latestBalanceEntry.Debit;
          isLastTxPayout = false;
        }
      }

      /* ---------------- INITIALS ---------------- */
      const words = (clickedData.party_name || "").trim().split(/\s+/);
      const shortName = words.map((w) => (w[0] || "").toUpperCase()).join("").slice(0, 3);

      const now = moment().format("DD MMM YY · hh:mm A");
      const pageWidth = doc.internal.pageSize.getWidth();
      let y = 6;

      /* ================= HEADER ================= */
      // Circle with initials
      doc.setFillColor(30, 144, 255);
      doc.circle(14, y + 11, 10, "F");

      doc.setFontSize(14);
      doc.setTextColor(255, 255, 255);
      doc.setFont("helvetica", "bold");
      doc.text(shortName, 14, y + 13, { align: "center" });

      // Party name
      doc.setFontSize(18);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "bold");

      let displayName = (clickedData.party_name || "").trim();
      if (doc.getTextWidth(displayName) > pageWidth - 90) {
        displayName = displayName.substring(0, 28) + "...";
      }
      doc.text(displayName, 30, y + 9);

      /* ================= LAST TRANSACTION AMOUNT (TOP RIGHT) ================= */

      if (lastTransactionAmount !== null && lastTransactionAmount !== undefined) {
        const amountText = Number(lastTransactionAmount).toLocaleString("en-IN");

        doc.setTextColor(isLastTxPayout ? 0 : 220, isLastTxPayout ? 180 : 0, 0);
        doc.setFontSize(22);
        doc.setFont("helvetica", "bold");

        doc.text(amountText, pageWidth - 8 - doc.getTextWidth(amountText), y + 9);
      }

      // Date & "You got"/"You gave"
      doc.setFontSize(13);
      doc.setTextColor(110, 110, 110);
      doc.setFont("helvetica", "normal");

      doc.text(now, 30, y + 18);

      const actionText = isLastTxPayout ? "You got" : "You gave";
      doc.text(actionText, pageWidth - 8 - doc.getTextWidth(actionText), y + 18);

      y += 28;

      /* ================= DIVIDER ================= */
      doc.setDrawColor(220, 220, 220);
      doc.setLineWidth(0.5);
      doc.line(5, y, pageWidth - 5, y);

      y += 10;

      /* ================= LAST DETAILS ================= */
      doc.setFontSize(14);
      doc.setTextColor(90, 90, 90);
      doc.text("Last Transaction", 6, y);

      y += 9;

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");

      if (latestParticulars) {
        const splitText = doc.splitTextToSize(latestParticulars, pageWidth - 14);
        doc.text(splitText, 6, y);
        y += splitText.length * 7 + 4;
      } else {
        y += 8;
      }

      /* ================= SECOND DIVIDER ================= */
      doc.setDrawColor(220, 220, 220);
      doc.line(5, y, pageWidth - 5, y);

      y += 14;

      /* ================= FINAL BALANCE ================= */
      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.text("Running Balance", 6, y);

      const balanceAbs = Math.abs(finalBalance).toLocaleString("en-IN");
      const balanceSign = finalBalance >= 0 ? "" : "-";
      const balanceText = `${balanceSign}${balanceAbs}`;

      // Color: **Red** = they owe us (positive), **Green** = we owe them (negative)
      const isTheyOweUs = finalBalance >= 0;
      doc.setTextColor(isTheyOweUs ? 220 : 0, isTheyOweUs ? 0 : 180, 0);
      doc.setFontSize(26);
      doc.setFont("helvetica", "bold");

      doc.text(balanceText, pageWidth - 8 - doc.getTextWidth(balanceText), y + 2);

      /* ================= EXPORT → Upload → WhatsApp ================= */
      const pdfBlob = doc.output("blob");

      const formData = new FormData();
      formData.append("reqtype", "fileupload");
      formData.append("time", "72h");

      const safeName = (clickedData.party_name || "party")
        .replace(/[^a-zA-Z0-9]/g, "_")
        .substring(0, 45);

      const fileName = `${safeName}_Statement.pdf`;
      formData.append("fileToUpload", pdfBlob, fileName);

      const uploadResponse = await fetch("https://litterbox.catbox.moe/resources/internals/api.php", {
        method: "POST",
        body: formData,
      });

      if (!uploadResponse.ok) {
        throw new Error("File upload failed");
      }

      const downloadLink = await uploadResponse.text();

      const cleanMobile = String(clickedData.mobile_number).replace(/[^\d]/g, "");
      const waNumber = cleanMobile.startsWith("91") ? cleanMobile : "91" + cleanMobile;

      const message = `Here's your latest statement:\n${downloadLink.trim()}`;
      const whatsappUrl = `https://wa.me/${waNumber}?text=${encodeURIComponent(message)}`;

      window.open(whatsappUrl, "_blank");
    } catch (error) {
      console.error("WhatsApp Statement Error:", error);
      toast.error("Failed to generate/send statement. Please try again.");
    }
  };
  const handleUpdateSubmit = async () => {
    if (!isValidEmail(crtPurchase.email)) {
      errorAlert("Invalid Email Address");
      return;
    }
    setLoading(true);
    try {
      const response = await fetch(`${API_DOMAIN}/purchase_party.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          company_id: companyId,
          edit_party_id: crtPurchase.party_id,
          party_name: crtPurchase.party_name,
          mobile_number: crtPurchase.mobile_number,
          alter_number: crtPurchase.alter_number,
          email: crtPurchase.email,
          city: crtPurchase.city,
          state: crtPurchase.state,
          company_name: crtPurchase.company_name,
          gst_no: crtPurchase.gst_no,
          address: crtPurchase.address,
          opening_balance: crtPurchase.opening_balance,
          opening_date: crtPurchase.opening_date,
          ac_type: crtPurchase.ac_type,
        }),
      });

      const responseData = await response.json();
      setLoading(false);

      if (responseData.status === 200) {
        await fetchData(true);
        successAlert(responseData.msg);
        handleClose();
      } else {
        errorAlert(responseData.msg || "Update failed");
      }
    } catch (error) {
      setLoading(false);
      errorAlert("Network or server error. Please try again.");
    }
  };

  const [isLoggedIn, setIsLoggedIn] = useState(true);
  useEffect(() => {
    const checkSession = async () => {
      try {
        const session = localStorage.getItem("session");
        if (!session) {
          setIsLoggedIn(false);
        }
      } catch (error) {
        setIsLoggedIn(false);
      }
    };
    checkSession();
  }, []);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const clickedDatapaidbalanlce = calculateTotals(
    clickedData ? clickedData.transactions : []
  );

  const isValidEmail = (email) => {
    if (!email) return true;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email.trim());
  };

  if (loading) {
    return (
      <LoadingSpinner message="Loading Purchase Party..." height="300px" />
    );
  }
  const generatePdf = () => {
    generatePurchasePartyPdf(clickedData, errorAlert, from_date, to_date);
  };

  const sortedTransactions = (clickedData?.transactions || []).slice().sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );

  const originalBalanceSheet = clickedData?.party_wise_balance_sheet_report || [];
  const openingBalanceValue = parseFloat(clickedData?.opening_balance || 0);
  const openingDate = clickedData?.opening_date || moment().format("YYYY-MM-DD");

  // 1. Sort Ascending Correctly First
  let sortedBalanceSheetWithOpening = originalBalanceSheet.slice().sort(
    (a, b) => new Date(a.Date) - new Date(b.Date)
  );

  // 2. Add Opening Balance if needed
  const isOpeningAlreadyIncluded =
    sortedBalanceSheetWithOpening.length > 0 &&
    sortedBalanceSheetWithOpening[0].Particulars?.toLowerCase().includes("opening");

  if (openingBalanceValue !== 0 && !isOpeningAlreadyIncluded) {
    const openingRow = {
      Date: openingDate,
      Particulars: "Opening Balance",
      Credit: openingBalanceValue > 0 ? openingBalanceValue : 0,
      Debit: openingBalanceValue < 0 ? Math.abs(openingBalanceValue) : 0,
      Balance: openingBalanceValue,
    };
    sortedBalanceSheetWithOpening.unshift(openingRow);
  }

  // 3. Calculate Running Balances (Ascending)
  let currentBalance = 0;
  const calculatedBalanceSheet = sortedBalanceSheetWithOpening.map((row, index) => {
      let credit = parseFloat(row.Credit || 0);
      let debit = parseFloat(row.Debit || 0);
      
      if (index === 0) {
           if (row.Particulars === "Opening Balance") {
               currentBalance = parseFloat(row.Balance || 0);
           } else {
               currentBalance = credit - debit;
           }
      } else {
           currentBalance = currentBalance + credit - debit;
      }
      
      return {
          ...row,
          Balance: currentBalance
      };
  });

  // 4. Sort Descending for Display
  const sortedBalanceSheet = calculatedBalanceSheet.slice().reverse();



  return (
    <div style={{ cursor: "pointer" }}>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <div>
        <Container fluid>
          <Row>
            <Col lg="4" className="py-1">
              <div className="main my-2">
                <Row className="mx-2">
                  <Col lg="6">
                    <div className="mx-2">
                      <TextInputForm
                        placeholder={"Name"}
                        onChange={(e) => handleSearch(e.target.value)}
                        prefix_icon={<FaMagnifyingGlass />}
                        labelname={"Search"}
                      >
                        {" "}
                      </TextInputForm>
                    </div>
                  </Col>

                  <Col
                    lg="6"
                    className="align-item-baseline d-flex justify-content-end"
                  >
                    <div>
                      <Buttons lable={<> Add New</>} onClick={handleShow} />
                    </div>
                  </Col>
                </Row>
                <div className="py-2 c-table">
                  <TableUI
                    headers={PurchasePartyTable}
                    pageview={"yes"}
                    body={filteredUserData}
                    type="partypurches"
                    handleEditClick={handleEditClick}
                    onClick={handleClick}
                    onDelete={fetchData}
                  />
                </div>
              </div>
            </Col>
            <Col lg="8">
              <div className="my-2">
                <div className="main">
                  {clickedData && (
                    <div className="mx-2">
                      <div className="d-flex justify-content-between  mb-2">
                        <div>Name : {clickedData.party_name}</div>
                        <div>
                          <span>
                            MobileNumber : {clickedData.mobile_number}
                          </span>
                        </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div>
                          <span>
                            Total Paid : {clickedDatapaidbalanlce.paid}
                          </span>
                        </div>
                        <div>
                          <span>
                            Total Balance : {clickedDatapaidbalanlce.balance}
                          </span>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="my-2">
                <div className="main">
                  <>
                    <Row className="mx-2">
                      <Col xs={12}>
                        <PageTitle PageTitle={<>Purchase Party Summary Details</>} />
                      </Col>
                    </Row>
                    <Row className="mx-2 mt-1 align-items-start">
                      <Col xs={0} lg={4}></Col>
                      <Col
                        xs={12}
                        lg={4}
                        className="d-flex justify-content-start mb-2 mb-lg-0"
                        style={{ marginTop: "-29px" }}
                      >
                        <div className="d-flex justify-content-start w-100 w-lg-autox">
                          <div
                            className="me-2"
                            style={{
                              width: "150px",
                              marginRight: "20px",
                              margintop: "-20px",
                            }}
                          >
                            <Calender
                              labelname={<>From</>}
                              key={resetKey}
                              value={
                                from_date
                                  ? moment(from_date, "YYYY-MM-DD").toDate()
                                  : null
                              }
                              setLabel={(value) =>
                                setDateLabel(value, "from_date")
                              }
                            />
                          </div>
                          <div style={{ width: "150px" }}>
                            <Calender
                              labelname={<>To</>}
                              key={resetKey}
                              value={
                                to_date
                                  ? moment(to_date, "YYYY-MM-DD").toDate()
                                  : null
                              }
                              setLabel={(value) =>
                                setDateLabel(value, "to_date")
                              }
                            />
                          </div>
                        </div>
                      </Col>

                      <Col
                        xs={12}
                        lg={4}
                        className="d-flex justify-content-end mb-2 mb-lg-0"
                      >
                        <div className="d-flex justify-content-end w-100 w-lg-auto">
                          <div className="me-2">
                            <Buttons
                              lable={<>Clear</>}
                              onClick={handleClearDates}
                              className="btn-sm"
                            />
                          </div>
                          <div>
                            <Buttons
                              lable={<>Download PDF</>}
                              onClick={generatePdf}
                              className="btn-sm"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>

                  <Offcanvas
                    show={openFilter}
                    onHide={closeFilter}
                    placement="end"
                  >
                    <Offcanvas.Body>
                      <Row>
                        <Col lg="6">
                          <PageTitle PageTitle={<>Purchase Party</>} />
                        </Col>
                        <Col lg="6" className="align-self-center">
                          <div className="text-end">
                            <Buttons
                              onClick={closeFilter}
                              lable={
                                <>
                                  <MdOutlineClose />
                                </>
                              }
                            ></Buttons>
                          </div>
                        </Col>
                      </Row>
                      <div className="py-3">
                        <TextInputForm labelname={<>Receipt No.</>} />
                      </div>
                      <div className="py-3">
                        <DropDownUI labelname={"Select Purchase Party"} />
                      </div>
                      <div className="py-3">
                        <DropDownUI labelname={" Select Type"} />
                      </div>
                      <Row>
                        <Col lg="6" className="align-self-center">
                          <div>
                            <Calender labelname={<>From</>} />
                          </div>
                        </Col>
                        <Col lg="6" className="align-self-center">
                          <div>
                            <Calender labelname={<>To</>} />
                          </div>
                        </Col>
                        <Col lg="6" className="align-self-center">
                          <div className="my-5 text-center">
                            <Buttons lable={"Apply"}></Buttons>
                          </div>
                        </Col>
                        <Col lg="6" className="align-self-center">
                          <div className="my-5 text-center">
                            <Buttons lable={"Clear"}></Buttons>
                          </div>
                        </Col>
                      </Row>
                    </Offcanvas.Body>
                  </Offcanvas>
                  <Tabs
                    defaultActiveKey="balancesheet" // Or "balancesheet" based on your preference
                    id="purchase-party-tabs"
                    className="mt-3 custom-tabs"
                  >


                    {/* TAB 2: TRANSACTIONS (Matching Sales Party Logic) */}
                    <Tab eventKey="transactions" title="Transactions">
                      <div className="py-2 c-table table-scroll mt-3">
                        <TableUI
                          headers={ProductHistory} // Ensure this is defined in your PurchaseParty.js
                          body={sortedTransactions}
                          type="partypurchasetransactions"
                          pageview={"yes"}
                        />
                      </div>
                    </Tab>

                    {/* TAB 3: BALANCE SHEET (Matching Sales Party Logic) */}
                    <Tab eventKey="balancesheet" title="Balance Sheet">
                      <div className="py-2 c-table table-scroll mt-3">
                        <TableUI
                          headers={BalanceSheetHeaders} // Ensure this is defined
                          body={sortedBalanceSheet}
                          type="partypurchasebalancesheet"
                          pageview={"yes"}
                          onWhatsAppSend={sendWhatsAppStatement} // Or your specific function
                        />
                      </div>
                    </Tab>
                  </Tabs>
                  {/* <div className="py-2 c-table table-scroll">
                    <TableUI
                      headers={PartyHistroy}
                      body={clickedData != null ? clickedData.transactions : []}
                      type="partypurchestransactions"
                      pageview={"yes"}
                      onWhatsAppSend={sendWhatsAppStatement}
                    ></TableUI>
                  </div> */}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
        <>
          <Modal show={show} onHide={handleClose} centered size="lg">
            <Modal.Header>
              <PageHead pagehead={<> Purchase Party</>} onClick={handleClose} />
            </Modal.Header>
            <Modal.Body>
              <Container>
                <Row>
                  <Col lg="4" className="py-3">
                    <TextInputForm
                      placeholder={"Company Name"}
                      labelname={"Company Name"}
                      name="party_name"
                      value={
                        crtPurchase != null
                          ? crtPurchase.party_name
                          : formData.party_name
                      }
                      onChange={(e) => handleChange(e, "party_name")}
                    ></TextInputForm>
                  </Col>
                  <Col lg="4" className="py-3">
                    <TextInputForm
                      labelname={"GST No"}
                      placeholder={"GST No"}
                      name="gst_no"
                      value={
                        crtPurchase != null
                          ? crtPurchase.gst_no
                          : formData.gst_no
                      }
                      onChange={(e) => handleChange(e, "gst_no")}
                    />
                  </Col>
                  <Col lg="4" className="py-3">
                    <TextInputForm
                      placeholder={"MobileNumber"}
                      labelname={"MobileNumber"}
                      name="mobile_number"
                      value={
                        crtPurchase != null
                          ? crtPurchase.mobile_number
                          : formData.mobile_number
                      }
                      onChange={(e) => handleChange(e, "mobile_number")}
                    ></TextInputForm>
                  </Col>
                  <Col lg="6" className="py-3">
                    <label className="pb-2">Address</label>
                    <textarea
                      className="form-cntrl form-control"
                      placeholder={"Address"}
                      labelname={"Address"}
                      name="address "
                      value={
                        crtPurchase != null
                          ? crtPurchase.address
                          : formData.address
                      }
                      onChange={(e) => handleChange(e, "address")}
                    />
                  </Col>
                </Row>
              </Container>

              <Container>
                <Row>
                  {/* Additional fields are commented out as in your original code */}
                </Row>
              </Container>
            </Modal.Body>
            <Modal.Footer>
              <div className="text-center py-4">
                {crtPurchase != null ? (
                  <>
                    <span className="mx-2">
                      <ClickButton
                        label={<>Update</>}
                        onClick={handleUpdateSubmit}
                        disabled={loading}
                      ></ClickButton>
                    </span>

                    <span className="mx-2">
                      <ClickButton
                        label={<>Cancel</>}
                        onClick={() => {
                          handleClose();
                        }}
                      ></ClickButton>
                    </span>
                  </>
                ) : (
                  <>
                    <span className="mx-2">
                      <ClickButton
                        label={<>Submit</>}
                        onClick={handleSubmit}
                        disabled={loading}
                      ></ClickButton>
                    </span>

                    <span className="mx-2">
                      <ClickButton
                        label={<>Cancel</>}
                        onClick={() => {
                          handleClose();
                        }}
                      ></ClickButton>
                    </span>
                  </>
                )}
              </div>
            </Modal.Footer>
          </Modal>
        </>
      </div>
    </div>
  )
};

export default Party;